
import React from 'react';

const TNC = () => {
  return (
    <div className='bg-gradient-to-br from-black to-gray-900 min-h-screen flex justify-center items-center p-4'>
      <div className='bg-white rounded-2xl shadow-2xl w-full max-w-3xl p-6 md:p-10 overflow-y-auto'>
        <h1 className='text-black text-3xl font-bold text-center mb-8'>Conditions générales</h1>
        <div className='text-black text-base space-y-6'>
          <div>
            <h2 className='font-semibold text-lg mb-2'>1. Description des services</h2>
            <p>
              Toonflix est un portail de divertissement pour enfants proposant une grande variété de vidéos de dessins animés amusantes et éducatives.
            Le service propose du contenu vidéo adapté à l'âge des enfants, mettant en vedette des personnages populaires, conçu pour divertir et inspirer les enfants.
            </p>
          </div>

          <div>
            <h2 className='font-semibold text-lg mb-2'>2. Plans d'abonnement et frais</h2>
             <p>
              En vous abonnant à Toonflix, vous acceptez d'être facturé selon le forfait que vous sélectionnez :<br />
              • Forfait quotidien : 100 FCFA/jour<br />
              • Forfait hebdomadaire : 300 FCFA/semaine<br />
              • Forfait mensuel : 500 FCFA/mois<br />
              Votre abonnement sera automatiquement renouvelé à la fin de chaque période de facturation et les frais seront déduits de votre solde mobile en conséquence.
            </p>
          </div>

          <div>
            <h2 className='font-semibold text-lg mb-2'>3. Admissibilité à l'abonnement</h2>
            <p>
               • Si vous avez moins de 18 ans, vous DEVEZ obtenir l’autorisation de la personne autorisée qui paie votre facture.<br/>
              • Le service est uniquement disponible pour les utilisateurs d'Orange Sénégal disposant de smartphones compatibles data.
            </p>
          </div>

          <div>
            <h2 className='font-semibold text-lg mb-2'>4. Accès et utilisation</h2>
            <p>
               • Vous pouvez accéder au portail Toonflix à tout moment pendant votre période d'abonnement active.<br/>
               • Le service nécessite une connexion internet active. Des frais de données peuvent s'appliquer selon votre forfait mobile.<br/>
               • Le contenu est destiné à un usage personnel et non commercial uniquement.<br/>
            </p>
          </div>

          <div>
            <h2 className='font-semibold text-lg mb-2'>5.Politique de désabonnement</h2>
            <p>
               • Vous pouvez vous désinscrire du service à tout moment via le portail officiel ou en utilisant le code SMS ou USSD approprié fourni.<br/>
              • En cas de désabonnement, l'accès au contenu sera résilié à la fin du cycle de facturation en cours. Aucun remboursement partiel ne sera effectué pour les périodes non utilisées.<br/>
             <span className='font-bold' >• Désinscription gratuite à tout moment : composez #303#10#.</span>
            </p>
          </div>

          <div>
            <h2 className='font-semibold text-lg mb-2'>6. Renouvellement automatique et facturation</h2>
            <p>
             • Les abonnements sont automatiquement renouvelés en fonction du forfait sélectionné, sauf si vous vous désabonnez avant la prochaine date de facturation..<br/>
             • Assurez-vous que le solde disponible est suffisant pour le renouvellement ; le fait de ne pas déduire le montant peut entraîner la suspension du service.
            </p>
          </div>

          <div>
            <h2 className='font-semibold text-lg mb-2'>7.Confidentialité et protection des données</h2>
            <p>
             • Vos données personnelles sont traitées conformément aux lois applicables en matière de   
                 protection des données.<br/>
              • Aucune donnée personnelle ne sera partagée avec des tiers sans votre consentement, sauf si la loi l'exige.
            </p>
          </div>

          <div>
            <h2 className='font-semibold text-lg mb-2'>8. Modification des Conditions</h2>
            <p>
             Toonflix se réserve le droit de modifier les présentes Conditions générales à tout moment. L'utilisation continue du service vaut acceptation des conditions mises à jour.
            </p>
          </div>

          <div>
            <h2 className='font-semibold text-lg mb-2'>9. Soutien</h2>
         <p>
Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-dire
  <a 
    className='text-blue-900 font-bold underline ml-1' 
    href='mailto:panz.support1@panzcon.com'
  >
    panz.support1@panzcon.com
  </a>.
</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TNC;
